"use client";

interface MechanicalClickProps {
    data: {
        mechanicalClickFooter: {
            title: string;
            subtitle: string;
        }[]
    };
}
export default function MechanicalClick({ data }: MechanicalClickProps) {
    return (
        <div className="flex justify-center max-sm:px-5 ">
            <div className="max-w-6xl w-full mx-4">
                {/* Top dark blue section */}
                <div
                    className="px-8 py-8 text-center text-white"
                    style={{ backgroundColor: '#032D60' }}
                >
                    <div className="text-3xl font-bold ">
                        {data.mechanicalClickFooter[0].title}
                    </div>
                    <p className="text-3xl  font-bold">
                        {data.mechanicalClickFooter[0].subtitle}
                    </p>
                </div>

                {/* Bottom light blue section */}
                <div
                    className="px-8 py-8 text-center"
                    style={{ backgroundColor: '#D6F0FF' }}
                >
                    <div className="text-3xl font-bold text-[#0095EB] mb-4">
                        {data.mechanicalClickFooter[1].title}
                    </div>
                    <p className="text-2xl text-[#032D60] font-semibold max-w-3xl mx-auto">
                        {data.mechanicalClickFooter[1].subtitle}
                    </p>
                </div>
            </div>
        </div>
    );
}